export const DIALOG_SUPPORT_COMPLETE_TITLE = `Спасибо! Тикет в поддержку отправлен`

export const DIALOG_SUPPORT_COMPLETE_CONTENT = `Мы постараемся как можно быстрее изучить Вашу проблему. Ответ от Агента поддержки Вы получите в уведомлении на сайте`

export const DIALOG_SUPPORT_COMPLETE_OK_BUTTON = `Закрыть`
